(() => {
// Components
// Sections
console.log("sdsa4");

})();
//# sourceMappingURL=parcel_scripts.js.map
